import {
	FETCH_NOTIFICATIONS,
	FETCH_NOTIFICATIONS_SUCCESS,
	FETCH_NOTIFICATIONS_FAIL
} from '../constants/ActionTypes';

export const fetchNotifications = (partnerID, userID) => ({
	type: FETCH_NOTIFICATIONS,
	partnerID,
	userID
});

export const fetchNotificationsSuccess = notifications => ({
	type: FETCH_NOTIFICATIONS_SUCCESS,
	notifications
});

export const fetchNotificationsFail = error => ({
	type: FETCH_NOTIFICATIONS_FAIL,
	error
});
